export default __webpack_public_path__ + "./images/bt.953dfad0.png";